import React from 'react';

const UpdateData = () => {
  return <div>UpdateData</div>;
};

export default UpdateData;
